import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"bottom":"","max-width":"300px","disabled":_vm.disabled},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VChip,_vm._g(_vm._b({staticClass:"ml-1",attrs:{"x-small":"","dark":"","color":_vm.content.color}},'v-chip',attrs,false),on),[_vm._v(" "+_vm._s(_vm.content.title)+" ")])]}}])},[_c('span',{staticClass:"text-caption"},_vm._l((_vm.content.text),function(text){return _c('p',{key:text,staticClass:"my-2"},[_vm._v(_vm._s(text))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }